// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs-active[data-v-3fe0b3ec]{background:#fbfbfb;border-radius:5px;margin:7px 0}.tabs[data-v-3fe0b3ec]{width:auto;display:inline-block}.tabs .v-tab[data-v-3fe0b3ec]:before{margin:7px 0}.v-tabs--vertical>.v-tabs-bar .v-tab[data-v-3fe0b3ec]{min-width:100%}", ""]);
// Exports
module.exports = exports;
